const THRESHOLD_TYPE_TO_DISPLAY = {
    above_fire_threshold_stream: 'High threshold',
    below_fire_threshold_stream: 'Low threshold',
    c_bot: 'Lower clear threshold',
    c_top: 'Upper clear threshold',
    cb: 'Lower clear threshold',
    clear_bot: 'Lower clear threshold',
    clear_hours_threshold_stream: 'Clear threshold',
    clear_pct_threshold_stream: 'Clear threshold',
    clear_threshold: 'Clear threshold',
    clear_threshold_signal: 'Clear threshold',
    clear_top: 'Upper clear threshold',
    ct: 'Upper clear threshold',
    error_budget_left_threshold: 'Error budget threshold',
    f_bot: 'Lower trigger threshold',
    f_top: 'Upper trigger threshold',
    fb: 'Lower trigger threshold',
    fire_bot: 'Lower trigger threshold',
    fire_hours_threshold_stream: 'Trigger threshold',
    fire_latency_static_threshold_stream: 'Trigger threshold',
    fire_over_limit_threshold_stream: 'Trigger threshold',
    fire_pct_threshold_stream: 'Trigger threshold',
    fire_threshold: 'Trigger threshold',
    fire_top: 'Upper trigger threshold',
    ft: 'Upper trigger threshold',
    limit_above: 'High threshold',
    limit_below: 'Low threshold',
    lower_threshold: 'Lower threshold',
    lower_threshold_signal: 'Lower threshold',
    phase_failed_fire_threshold_stream: 'Trigger threshold',
    phase_pending_fire_threshold_stream: 'Trigger threshold',
    slo_threshold: 'SLO threshold',
    threshold_signal_above: 'High threshold',
    threshold_signal_below: 'Low threshold',
    upper_fire_threshold: 'Upper trigger threshold',
    upper_threshold: 'Upper threshold',
};

const PLOT_TYPE_TO_DISPLAY = {
    ...THRESHOLD_TYPE_TO_DISPLAY,
    ats_stream: 'Active MTS',
    available_stream: 'Available',
    binary: 'Reporting status',
    clear_forecast: 'Clear forecast',
    containers_limit_stream: 'Container limit',
    containers_usage: 'Container usage',
    current_error_pct: 'Current error rate',
    current_num_stream: 'Current count',
    current_p50: 'Current latency (P50)',
    current_stream: 'Current value',
    current_utilization: 'Current utilization',
    custom_metrics_limit_stream: 'Custom metrics limit',
    custom_metrics_stream: 'Custom metrics used',
    custom_mts_usage_percentage: 'Custom mts usage',
    desired_stream: 'Desired',
    detectors_with_quality_issues_stream: 'Detectors with quality issues',
    err_pct: 'Current error rate',
    error_budget_left: 'Error budget left',
    error_stream: 'Errors',
    evicted_keys_stream: 'Evicted keys',
    expired_keys_stream: 'Expired keys',
    failed_pods_stream: 'Failed pods',
    fire_forecast: 'Trigger forecast',
    good_count: 'Good count',
    good_events_stream: 'Good events',
    hist: 'Baseline latency',
    historical_p50: 'Baseline latency (P50)',
    host_usage_percentage: 'Host usage',
    hosts_limit_stream: 'Hosts limit',
    hosts_stream: 'Hosts',
    hours_left: 'Hours left',
    iqr_of_historical_window: 'IQR of historical window',
    limit_stream: 'Limit',
    limits_stream: 'Limits',
    median_of_historical_window: 'Median of historical window',
    metric_names: 'Metric names',
    non_error_stream: 'Non-errors',
    percentage: 'Detector capacity used',
    population_MAD: 'Population MAD',
    population_median: 'Population median',
    preceding_error_pct: 'Baseline error rate',
    ready_stream: 'Ready',
    recent_max: 'Recent max',
    recent_mean: 'Recent mean',
    recent_min: 'Recent min',
    request_rate: 'Request rate',
    resource_limit: 'Resource limit',
    scheduled_stream: 'Scheduled',
    successful_pods_stream: 'Successful pods',
    summary: 'Rolling mean',
    sys_cpu_stream: 'System CPU',
    total_count: 'Total count',
    total_events_stream: 'Total events',
    user_cpu_stream: 'User CPU',
    var: 'Variance',
    vol: 'Volume',
    window_good_events: 'Window good events',
    window_total_events: 'Window total events',
};

export default {
    getDisplayFor(type) {
        if (typeof type !== 'string') {
            return '';
        }
        const thresholdType = Object.keys(PLOT_TYPE_TO_DISPLAY).find((prefix) =>
            type.startsWith(prefix)
        );
        return thresholdType ? PLOT_TYPE_TO_DISPLAY[thresholdType] : '';
    },

    isThresholdType(type) {
        return Object.keys(THRESHOLD_TYPE_TO_DISPLAY).some((prefix) => type.startsWith(prefix));
    },

    isKnownPlotType(type) {
        return Object.keys(PLOT_TYPE_TO_DISPLAY).some((prefix) => type.startsWith(prefix));
    },
};
